<script>
import { connect } from 'vuex-connect';
import CancelDialogBox from '../scenes/CancelDialogBox.vue';

export default connect({
  actionsToEvents: {
    cancel: 'goBack',
    confirm: 'cancelLaunchAndRedirect',
  },
})('CancelDialogBox', CancelDialogBox);
</script>
